export const ossNavigationItems = [
  { label: "운영 현황", path: "", icon: "homeIcon" },
  { label: "주문 목록", path: "orders", icon: "checklistIcon" },
  { label: "조치 필요", path: "actions", icon: "warningIcon" },
  { label: "변경 검토", path: "changes", icon: "checklistIcon" },
  { label: "문서 관리", path: "documents", icon: "folderIcon" },
  { label: "기준정보", path: "standards", icon: "settingsIcon" },
  // 시연 범위에서 제외되어 사이드바 노출을 잠시 막아둡니다.
  // { label: "연계 모니터", path: "integrations", icon: "databaseIcon" },
  // { label: "보고서", path: "reports", icon: "chartIcon" },
];

export const ossNavigationIconByPath = ossNavigationItems.reduce((acc, item) => {
  acc[item.path || "dashboard"] = item.icon;
  return acc;
}, {});
